function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_11614_69963)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 32,
  r: 28,
  fill: "#7D00FF"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_11614_69963)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.3332 22.6667H35.4457V26.2956H46.3332V22.6667ZM28.1853 26.2956H24.5561V29.9267H28.1853V26.2956ZM24.5561 44.4445H28.1853V33.5556H24.5561V44.4445ZM31.8144 26.2956V29.9267H35.4457V26.2956H31.8144ZM31.8144 44.4445H35.4457V33.5556H31.8144V44.4445ZM31.8144 22.6667H28.1853V26.2956H31.8144V22.6667ZM13.6665 22.6667V26.2956H24.5561V22.6667H13.6665ZM46.3332 33.5556V29.9267H35.4457V33.5556H46.3332ZM28.1853 29.9267V33.5556H31.8144V29.9267H28.1853ZM13.6665 29.9267V33.5556H24.5561V29.9267H13.6665Z",
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_11614_69963",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11614_69963"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11614_69963",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11614_69963"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32.6667,
  height: 21.7778,
  fill: "white",
  transform: "translate(13.6665 22.6667)"
})));

const SvgTTokenSymbol = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTTokenSymbol, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/t-token-symbol.7e229c6b.svg";
export { ForwardRef as ReactComponent };